import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import { Login } from './pages/Login';
import { Error } from './pages/Error';
import { NotFound } from './pages/NotFound';
import { Access } from './pages/Access';

import { Landing } from './pages/landing/Landing';
import { Profile } from './pages/profile/Profile';

import i18next from './config/i18n';
import { I18nextProvider } from 'react-i18next';
import { Register } from './pages/Register';
import { Verification } from './pages/Verification';
import { withRouter } from './common/withRouter';
import { Error401 } from './errors/Error401';
import { EmptyPage } from './errors/EmptyPage';
import { Error500 } from './errors/Error500';
import { ErrorPermission } from './errors/ErrorPermission';

import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/free-solid-svg-icons';
import '@fortawesome/free-regular-svg-icons';
import '@fortawesome/free-brands-svg-icons';
import '@fortawesome/react-fontawesome';


import { library, config } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import '../node_modules/@fortawesome/fontawesome-svg-core/styles.css'

import '@fortawesome/fontawesome-free/css/all.min.css';
import ProtectedRoute from './security/ProtectedRoute';
import { Exhibition } from './pages/exhibition/Exhibition';
import { Exhibit } from './pages/exhibit/Exhibit';
import { Favorites } from './pages/favorites/Favorites';
import { Search } from './pages/search/Search';

import { Contract } from './pages/contracts/Contract';


library.add(fas);
config.autoAddCss = true;

const AppWrapper = (props) => {
    const [colorScheme, setColorScheme] = useState('light')
    const [theme, setTheme] = useState('blue');
    const [componentTheme, setComponentTheme] = useState('blue');

    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const onColorSchemeChange = (scheme) => {
        changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
        changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);
        setColorScheme(scheme);
    };

    console.log("AppWrapper", colorScheme, props);

    const changeStyleSheetUrl = (id, value, from) => {
        const element = document.getElementById(id);
        const urlTokens = element.getAttribute('href').split('/');

        if (from === 1) {
            // which function invoked this function - change scheme
            urlTokens[urlTokens.length - 1] = value;
        } else if (from === 2) {
            // which function invoked this function - change color
            urlTokens[urlTokens.length - 2] = value;
        }

        const newURL = urlTokens.join('/');

        replaceLink(element, newURL);
    };

    const onMenuThemeChange = (theme) => {
        const layoutLink = document.getElementById('layout-css');
        const href = '/assets/layout/css/' + theme + '/layout-' + colorScheme + '.css';

        replaceLink(layoutLink, href);
        setTheme(theme);
    };

    const onComponentThemeChange = (theme) => {
        const themeLink = document.getElementById('theme-css');
        const href = '/assets/theme/' + theme + '/theme-' + colorScheme + '.css';

        replaceLink(themeLink, href);
        setComponentTheme(theme);
    };

    const replaceLink = (linkElement, href, callback) => {
        const id = linkElement.getAttribute('id');
        const cloneLinkElement = linkElement.cloneNode(true);

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

        cloneLinkElement.addEventListener('load', () => {
            linkElement.remove();
            const _linkElement = document.getElementById(id);
            _linkElement && _linkElement.remove();
            cloneLinkElement.setAttribute('id', id);

            if (callback) {
                callback();
            }
        });
    };
    /* 
        const getPath = (path) => {
            console.log("getPath",path); 
            if (path === ("/appointment")) {
                return "/appointment";
            } else if (path.startsWith("/appointmentinfo")) {
                return "/appointmentinfo";
            } else if (path.startsWith("/appointmentcheck")) {
                return "/appointmentcheck";
            } else if (path.startsWith("/appointment")) {
                return "/appointment/path";
            } else if (path.startsWith("/livesession")) {
                return "/livesession";
            } else {
                return path;
            }
        }
    
        switch (getPath(location.pathname)) {
    
            case '/login':
                return <Route path="/login" render={() => <Login colorScheme={colorScheme} />} />
            case '/error':
                return <Route path="/error" render={() => <Error colorScheme={colorScheme} />} />
            case '/notfound':
                return <Route path="/notfound" render={() => <NotFound colorScheme={colorScheme} />} />
            case '/access':
                return <Route path="/access" render={() => <Access colorScheme={colorScheme} />} />
            case '/landing':
                { console.log(props?.location?.pathname); }
                return <Route path='/landing' render={() => <Landing colorScheme={colorScheme} />} />
            default:
                { console.log(props?.location?.pathname); }
                return <App colorScheme={colorScheme} onColorSchemeChange={onColorSchemeChange}
                    componentTheme={componentTheme} onComponentThemeChange={onComponentThemeChange}
                    theme={theme} onMenuThemeChange={onMenuThemeChange} />;
        }
     */
    return (
        <I18nextProvider i18n={i18next}>

            <Routes>
                <Route path="/error" element={<Error />} />
                <Route path="/notfound" element={<NotFound />} />
                <Route path="/access" element={<Access />} />
                <Route path="/login" element={<Login {...props} />} />
                <Route path="/register" element={<Register {...props} />} />
                <Route path="/landing/:usermail/:verificationToken/:action" element={<Landing colorScheme={colorScheme} {...props} />} />
                <Route path="/landing/:action" element={<Landing colorScheme={colorScheme} {...props} />} />

                <Route path='*' element={<Landing colorScheme={colorScheme} {...props} />} {...props} />
                <Route path='/search' element={<Search colorScheme={colorScheme} {...props} />} {...props} />



                <Route element={<Profile colorScheme={colorScheme} {...props} />} path="/profile/:profileId/:userType" />

                <Route element={<Exhibit colorScheme={colorScheme} {...props} />} path="/exhibit/:profileId" />


                <Route element={<Favorites colorScheme={colorScheme} {...props} />} path="/favorites" />

                <Route path='/exhibition/:viewType/:profileId' element={<Exhibition colorScheme={colorScheme} {...props} />} {...props} />
                <Route path='/contract/:resourceCode' element={<Contract colorScheme={colorScheme} {...props} />} {...props} />


                <Route path="/admin/*" element={<App colorScheme={colorScheme} onColorSchemeChange={onColorSchemeChange}
                    componentTheme={componentTheme} onComponentThemeChange={onComponentThemeChange}
                    theme={theme} onMenuThemeChange={onMenuThemeChange} {...props} />} />




                <Route path="/emptypage" element={<EmptyPage {...props} />} />
                <Route path="/error401" element={<Error401 {...props} />} />
                <Route path="/error500" element={<Error500 {...props} />} />
                <Route path="/errorpermission" element={<ErrorPermission {...props} />} />


            </Routes>
        </I18nextProvider>
    );

};

export default withRouter(AppWrapper);
